import React from "react";
import Header from "../../../shared/layout/Header";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import OrderDetails from "../components/OrderDetails";
import ScrollToTop from "react-scroll-to-top";
//import AddressBook from "../../account/components/AddressBook";

const OrderDetailsPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <Header />
      <div className="container container-lg">
        <OrderDetails />
      </div>
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default OrderDetailsPage;
